/**
 * sl-9fmv.6.5: Workflow-patch live-apply module.
 *
 * Wires the PendingPatchRegistry into the WorkspaceScope so both the
 * AutomationSocketService (event producer) and the UI layer (diff preview
 * + accept/reject controls) can resolve the same instance.
 */
import type { Framework } from '@toeverything/infra';

import { WorkspaceScope } from '../../workspace';
import { PendingPatchRegistry } from './entities/pending-patch-registry';

export {
  PendingPatchRegistry,
  routeWorkflowPatchEvent,
} from './entities/pending-patch-registry';

export function configureWorkflowPatchModule(framework: Framework): void {
  framework.scope(WorkspaceScope).entity(PendingPatchRegistry);
}
